<nav aria-label="breadcrumb">
    <ol class="breadcrumb">
        <ng-container *ngIf="type === 'equipment' && equipmentItem">
            <li class="breadcrumb-item">{{ equipmentItem.site.label }}</li>
            <mat-icon svgIcon="total-arrow-right"></mat-icon>
            <li class="breadcrumb-item">{{ equipmentItem.unity.label }}</li>
            <mat-icon svgIcon="total-arrow-right"></mat-icon>
            <li class="breadcrumb-item active" aria-current="page">{{ equipmentItem.name }}</li>
        </ng-container>
        <ng-container *ngIf="type === 'unity' && unityItem">
            <li class="breadcrumb-item">{{ unityItem.site.label }}</li>
            <mat-icon svgIcon="total-arrow-right"></mat-icon>
            <li class="breadcrumb-item active" aria-current="page">{{ unityItem.label }}</li>
        </ng-container>
        <ng-container *ngIf="type === 'site' && siteItem">
            <li class="breadcrumb-item active" aria-current="page">{{ siteItem.label }}</li>
        </ng-container>
    </ol>
</nav>
